<template>
	<section class="ce-accordion">
		<div @click="toggleAccordion" class="toggler">
			<h3>{{objectdata.mooHeadline}}</h3>
		</div>
		<div class="accordion">
			<!-- <p v-html="objectdata.text"/> -->
			<p v-bind:inner-html.prop="objectdata.text | replaceNbsp | replaceAmp"/>
		</div>
	</section>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		}
	};
	/*scripts in base.vue*/
</script>

<style lang="scss">
	/*style in glonal-elements*/
</style>